module.exports = __webpack_public_path__ + "img/usun.b92b8285.svg";